module.exports = __webpack_public_path__ + "img/2_x2.4ddf1348.png";